export const frDocumentIntelligence: Record<string, string> = {
  "Employment history": "Historique des emplois",
  "Education and training": "Études et formation",
  "Certifications": "Certifications",
  "Currently employed": "Emploi actuel",
  "Unknown date": "Date inconnue",
  "Claimed calendar experience": "Expérience civile déclarée",
  "days, overlapping jobs counted once": "jours, les emplois simultanés comptés une seule fois",
  "entries excluded for missing dates": "entrées exclues faute de dates",
  "This does not award verified skill hours.": "Cela n’accorde aucune heure de compétence vérifiée.",
  "Refresh profile suggestions": "Actualiser les suggestions du profil",
  "Profile ingestion summary": "Bilan de l’importation du profil",
  "Employment entries added": "Emplois ajoutés",
  "Existing employment entries matched": "Emplois existants reconnus",
  "Skills added to profile": "Compétences ajoutées au profil",
  "Skills matched to existing catalogue": "Compétences associées au catalogue existant",
  "Canonical catalogue additions": "Ajouts au catalogue",
  "Catalogue proposals awaiting review": "Propositions de catalogue à examiner",
  "Catalogue proposals submitted": "Propositions de catalogue soumises",
  "Languages added": "Langues ajoutées",
  "Items awaiting review": "Éléments à examiner",
  "semantic": "Correspondance sémantique",
  "catalogue_created": "Ajout autorisé au catalogue",
  "Claimed experience": "Expérience déclarée",
  "years": "années",
  "hours": "heures",
  "Self-reported": "Autodéclaré",
  "Start date (year, month or date)": "Date de début (année, mois ou date)",
  "End date (year, month or date)": "Date de fin (année, mois ou date)",
  "Use calendar dates from 1900 to 2100. Partial and missing dates are retained; select currently employed for ongoing work.": "Utilisez des dates de 1900 à 2100. Les dates partielles ou inconnues sont conservées; indiquez si l’emploi est actuel.",
  "AI-assisted self-reported employment; check source and dates.": "Emploi autodéclaré extrait avec l’IA; vérifiez la source et les dates.",
  "AI-assisted source claim; worker review required.": "Déclaration extraite avec l’IA; examen par le travailleur requis.",
  "AI-assisted match; check source meaning before approval.": "Correspondance proposée par l’IA; vérifiez le sens dans la source avant d’approuver.",
  "Self-reported employment capability; no duration or proficiency inferred.": "Compétence professionnelle autodéclarée; aucune durée ni maîtrise déduite.",

  "Document-derived claim": "Déclaration tirée du document",
  "Verified skill": "Compétence vérifiée",
  "Unverified skill": "Compétence non vérifiée",
  "unassessed": "Non évaluée",
  "Professional skills": "Compétences professionnelles",
  "Unmatched capabilities": "Compétences sans correspondance",
  "Other suggestions": "Autres suggestions",
  "catalogue_reviewed": "Examinée dans le catalogue",
  "Matching status": "Correspondance au catalogue",
  "Select canonical skill": "Choisir une compétence du catalogue",
  "Refresh skill matching": "Actualiser les correspondances des compétences",
  "exact": "Exacte",
  "alias": "Alias",
  "strong": "Forte",
  "ambiguous": "Ambiguë",
  "Catalogue review required. Accepting submits a proposal; the skill is not linked until catalogue review.": "Examen du catalogue requis. L’acceptation soumet une proposition; aucune compétence n’est liée avant cet examen.",
  "Document-derived capability; review canonical matching before approval.": "Compétence tirée du document; vérifiez la correspondance au catalogue avant l’approbation.",
  "Pending catalogue proposal; acceptance requests catalogue review and does not link a canonical skill.": "Proposition au catalogue en attente; l’acceptation demande un examen sans lier une compétence du catalogue.",

  "The request could not be confirmed. Refresh your documents before retrying.": "La demande n’a pas pu être confirmée. Actualisez vos documents avant de réessayer.",
  "Retry document categories": "Réessayer de charger les catégories de documents",
  "Document uploaded.": "Document téléversé.",
  "CV / Résumé": "CV / Curriculum vitæ",
  "Driver's Licence": "Permis de conduire",
  "Identity Document": "Pièce d’identité",
  "Work Permit": "Permis de travail",
  "Trade Certification": "Certification professionnelle",
  "Equipment Operator Certification": "Certification de conduite d’équipement",
  "Training Certificate": "Attestation de formation",
  "Employment Document": "Document d’emploi",
  "Upload is available. Automatic extraction is unavailable for this category or configuration.": "Le téléversement est disponible. L’extraction automatique est indisponible pour cette catégorie ou configuration.",
  "Uploading document…": "Téléversement du document…",
  "Requesting extraction…": "Demande d’extraction…",
  "Extraction queued.": "Extraction en file d’attente.",
  "Document uploaded. Extraction could not start; the original is available.": "Document téléversé. L’extraction n’a pas pu démarrer; l’original est disponible.",
  "Extraction is taking longer than expected. The document is uploaded; refresh extraction for its current status.": "L’extraction prend plus de temps que prévu. Le document est téléversé; actualisez l’extraction pour connaître son état.",
  "Source evidence": "Preuve source",
  "Document intelligence": "Analyse de documents",
  "Extract suggestions for your profile. Only approved changes are applied. Documents and credential claims still require separate verification.": "Extrayez des suggestions pour votre profil. Seuls les changements approuvés sont appliqués. Les documents et les déclarations de qualification nécessitent une vérification distincte.",
  "I agree to process this document for profile suggestions.": "J’accepte le traitement de ce document pour obtenir des suggestions de profil.",
  "Document category": "Catégorie de document",
  "Resume": "CV",
  "Driver licence": "Permis de conduire",
  "Passport": "Passeport",
  "Other": "Autre",
  "Choose document": "Choisir un document",
  "Maximum file size": "Taille maximale du fichier",
  "Choose a non-empty file within the upload limit.": "Choisissez un fichier non vide respectant la limite de taille.",
  "Upload and extract suggestions": "Téléverser et extraire les suggestions",
  "Stored document": "Document enregistré",
  "Refresh extraction": "Actualiser l’extraction",
  "Retry extraction": "Réessayer l’extraction",
  "Extract suggestions": "Extraire les suggestions",
  "Processing document request…": "Traitement de la demande…",
  "The request could not be confirmed. Refresh extraction before trying again.": "La demande n’a pas pu être confirmée. Actualisez l’extraction avant de réessayer.",
  "Processing status": "État du traitement",
  "Extraction incomplete": "Extraction incomplète",
  "No profile suggestions are available. You can keep the document and update your profile manually.": "Aucune suggestion de profil n’est disponible. Vous pouvez conserver le document et modifier votre profil manuellement.",
  "Accept all eligible suggestions": "Accepter toutes les suggestions admissibles",
  "Rejecting suggestions keeps the original document.": "Le rejet des suggestions conserve le document original.",
  "Existing value": "Valeur actuelle",
  "Source value": "Valeur source",
  "Suggested value": "Valeur suggérée",
  "Validation": "Validation",
  "Enter a valid structured value or restore the suggestion.": "Saisissez une valeur structurée valide ou rétablissez la suggestion.",
  "Accept suggestion": "Accepter la suggestion",
  "Reject suggestion": "Rejeter la suggestion",
  "firstName": "Prénom",
  "lastName": "Nom de famille",
  "bio": "Présentation",
  "employment": "Emploi",
  "skills": "Compétences",
  "phone": "Téléphone",
  "email": "Courriel",
  "languages": "Langues",
  "Extracted suggestions": "Suggestions extraites",
  "Use the existing upload button below to choose a file, then select the stored document here.": "Utilisez le bouton de téléversement ci-dessous pour choisir un fichier, puis sélectionnez le document enregistré ici.",
  "Apply suggestions": "Appliquer les suggestions",
  "Keep document only": "Conserver le document uniquement",
  "Queued": "En file d’attente",
  "Processing": "Traitement en cours",
  "Pending": "En attente",
  "Ready for review": "Prêt pour révision",
  "Review required": "Révision requise",
  "Completed": "Terminé",
  "Reviewed": "Révisé",
  "Failed": "Échec",
  "Unsupported": "Non pris en charge",
  "Cancelled": "Annulé",
  "Expired": "Expiré",
  "Pending decision": "En attente de décision",
  "Accepted": "Acceptée",
  "Rejected": "Rejetée",
  "Applied": "Appliquée",
  "Identity card": "Carte d’identité",
  "Work permit": "Permis de travail",
  "Certificate": "Certificat",
  "Training certificate": "Certificat de formation",
  "Trade certificate": "Certificat de métier",
  "Job title": "Intitulé du poste",
  "Employer or organization": "Employeur ou organisation",
  "Start date": "Date de début",
  "End date": "Date de fin",
  "Description": "Description",
  "Check dates against the source. Missing dates are not inferred.": "Vérifiez les dates dans le document source. Les dates manquantes ne sont pas déduites.",
  "Extraction source": "Source d’extraction",
  "Processed at": "Traité le",
  "Valid format": "Format valide",
  "Invalid format": "Format invalide",
  "Extraction does not verify authenticity, identity, qualifications or compliance.": "L’extraction ne vérifie pas l’authenticité, l’identité, les qualifications ni la conformité.",
  "No supported document structure found.": "Aucune structure de document prise en charge n’a été trouvée."
}

export const intelligenceFieldLabels: Record<string, string> = {
  "firstName": "First name",
  "lastName": "Last name",
  "full_name": "Full name",
  "given_names": "First name",
  "family_name": "Last name",
  "bio": "Professional summary",
  "summary": "Professional summary",
  "languages": "Languages",
  "phone": "Phone number",
  "email": "Email address",
  "employment": "Employment",
  "skills": "Skills",
  "location": "Location",
  "education": "Education",
  "total_career_experience": "Total career experience",
  "skill_experience": "Skill experience",
  "credential_claim": "Credential claim",
  "issueDate": "Issue date",
  "issue_date": "Issue date",
  "expiryDate": "Expiry date",
  "expiry_date": "Expiry date",
  "issuingAuthority": "Issuing authority",
  "jurisdiction": "Issuing authority",
  "licenseClass": "Licence class",
  "license_class": "Licence class",
  "documentNumber": "Document number",
  "document_number": "Document number",
  "birth_date": "Date of birth",
  "issuing_country": "Issuing country",
  "nationality": "Nationality",
  "restrictions": "Restrictions",
  "endorsements": "Endorsements",
  "address": "Address"
}
export const intelligenceCategoryLabels: Record<string, string> = {
  "resume": "Resume",
  "driver_license_id": "Driver licence",
  "drivers_license": "Driver licence",
  "national_identity_card": "Identity card",
  "national_id": "Identity card",
  "passport": "Passport",
  "work_permit": "Work permit",
  "residence_permit": "Residence permit",
  "certificate": "Certificate",
  "training_card": "Training certificate",
  "safety_training_certificate": "Training certificate",
  "trade_certificate": "Trade certificate",
  "trade_certification": "Trade certificate",
  "equipment_operator_certification": "Equipment operator certificate",
  "education_document": "Education document",
  "employment_letter": "Employment letter",
  "other": "Other"
}

Object.assign(frDocumentIntelligence, {
  "First name": "Prénom",
  "Last name": "Nom de famille",
  "Full name": "Nom complet",
  "Professional summary": "Résumé professionnel",
  "Languages": "Langues",
  "Phone number": "Numéro de téléphone",
  "Email address": "Adresse courriel",
  "Employment": "Emploi",
  "Skills": "Compétences",
  "Location": "Lieu",
  "Education": "Formation",
  "Total career experience": "Expérience professionnelle totale",
  "Skill experience": "Expérience par compétence",
  "Credential claim": "Qualification déclarée",
  "Issue date": "Date de délivrance",
  "Expiry date": "Date d’expiration",
  "Issuing authority": "Autorité de délivrance",
  "Licence class": "Classe de permis",
  "Document number": "Numéro de document",
  "Date of birth": "Date de naissance",
  "Issuing country": "Pays de délivrance",
  "Nationality": "Nationalité",
  "Restrictions": "Restrictions",
  "Endorsements": "Mentions",
  "Address": "Adresse",
  "Residence permit": "Titre de séjour",
  "Equipment operator certificate": "Certificat de conduite d’équipement",
  "Education document": "Document de formation",
  "Employment letter": "Lettre d’emploi",
  "Line": "Ligne",
  "CV information is self-reported and requires confirmation.": "Les renseignements du CV sont déclarés par le travailleur et doivent être confirmés.",
  "Confirm extracted name.": "Confirmez le nom extrait.",
  "Possible name inferred only from first-line placement; confirm.": "Nom possible repéré en première ligne seulement; confirmez-le.",
  "Confirm ownership of this email.": "Confirmez que cette adresse courriel vous appartient.",
  "Country code is not inferred; confirm contact number.": "L’indicatif du pays n’est pas déduit; confirmez le numéro de téléphone.",
  "Location claim; confirm before applying.": "Lieu déclaré; confirmez-le avant de l’appliquer.",
  "Do not infer language proficiency beyond the written claim.": "Ne déduisez pas un niveau de langue au-delà de la déclaration écrite.",
  "Unverified skill claims; canonical skill/alias matching must be performed separately.": "Compétences non vérifiées; leur correspondance avec le catalogue doit être établie séparément.",
  "Employment is a self-reported claim; no exact experience hours inferred.": "L’emploi est une déclaration du travailleur; aucune heure d’expérience exacte n’est déduite.",
  "Employer and job title could not be separated reliably.": "L’employeur et le poste n’ont pas pu être distingués de façon fiable.",
  "Missing or uncertain employment dates retained.": "Les dates d’emploi manquantes ou incertaines sont conservées.",
  "Employment end date precedes start date; correct before acceptance.": "La fin de l’emploi précède son début; corrigez les dates avant d’accepter.",
  "Unverified education claim; no degree or completion inferred.": "Formation non vérifiée; aucun diplôme ni achèvement n’est déduit.",
  "Self-reported professional summary.": "Résumé professionnel déclaré par le travailleur.",
  "Unverified credential claim; separate credential evidence and approval are required.": "Qualification non vérifiée; des preuves et une approbation distinctes sont requises.",
  "No useful fields found; review the source document manually.": "Aucun champ utile trouvé; examinez le document source manuellement.",
  "Employment entries may overlap; no total career duration or skill hours calculated.": "Les emplois peuvent se chevaucher; aucune durée totale ni heure de compétence n’est calculée.",
  "Identity field requires review.": "Ce renseignement d’identité doit être examiné.",
  "All extracted identity fields require human review; check digits do not establish authenticity.": "Tous les renseignements d’identité extraits doivent être examinés; les chiffres de contrôle ne prouvent pas l’authenticité.",
  "Document appears expired based on the extracted date; not authority verification.": "La date extraite semble indiquer un document expiré; ce résultat n’est pas une vérification officielle.",
  "Summary exceeds profile length; shorten before approval.": "Le résumé dépasse la longueur permise; raccourcissez-le avant l’approbation.",
  "Conflicting source values; update this profile field manually.": "Les valeurs sources se contredisent; modifiez ce champ du profil manuellement."
})

Object.assign(frDocumentIntelligence, {
  'Submit for catalogue review': 'Soumettre à l’examen du catalogue',
  'Submitted for catalogue review; not added to your skills': 'Soumis à l’examen du catalogue; non ajouté à vos compétences',
  'Saved to your skill profile': 'Enregistré dans votre profil de compétences',
})
